module.exports = __webpack_public_path__ + "static/media/twitter.c0ea2e6a.png";